const filter = [
  {text: 'Заводской номер', value: 'id', op: 'in'},
  {text: 'Лицензия', value: 'license', op: 'in'}
];

const sort = [
  {text: 'По заводскому номеру', value: 'id', type: 'asc', default: true},
  {text: 'По заводскому номеру', value: 'id', type: 'desc'}
];

export { filter, sort };
